import { CSSProperties, forwardRef, MouseEvent, ReactNode } from 'react';

import { cx } from '@libs/classnames';

import styles from './Card.module.css';

export type Props = {
  className?: string;
  style?: CSSProperties;
  active?: boolean;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  onClickCapture?: (e: MouseEvent<HTMLDivElement>) => void;
  onPointerDown?: (e: MouseEvent<HTMLDivElement>) => void;
  disabled?: boolean;
  flat?: boolean;
  modal?: boolean;
  noShadow?: boolean;
  children: ReactNode;
  theme?: 'club' | 'grand-prix' | 'premium-rcf-red' | 'premium-rcf-green';
};
export const Card = forwardRef<HTMLDivElement, Props>(function CardInner(
  {
    className,
    onClick,
    onClickCapture,
    onPointerDown,
    style,
    active,
    disabled,
    flat,
    modal,
    noShadow,
    children,
    theme,
  }: Props,
  ref,
) {
  return (
    <div
      ref={ref}
      style={style}
      className={cx(
        styles.root,
        {
          [styles.disabled]: disabled,
          [styles.flat]: flat,
          [styles.active]: active,
          [styles.modal]: modal,
          [styles.noShadow]: noShadow,
          [styles.themeGrandPrix]: theme === 'grand-prix',
          [styles.themePremiumRcfRed]: theme === 'premium-rcf-red',
          [styles.themePremiumRcfGreen]: theme === 'premium-rcf-green',
        },
        className,
      )}
      onClick={onClick}
      onClickCapture={onClickCapture}
      onPointerDown={onPointerDown}
    >
      {children}
    </div>
  );
});
